import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router'
import { Button } from '@/components/occurrences/button'
import { PrototypeBar } from '@/components/occurrences/prototype-bar'
import { ROUTES } from '@/constants/routes'

export const AccessDenied = ({ message }: { message: string }) => {
	const navigate = useNavigate()
	return (
		<div className="flex flex-1 flex-col">
			<PrototypeBar />
			<div className="flex flex-1 flex-col items-center justify-center gap-3 p-8 text-center">
				<Lock className="size-10 text-kaefer-silver" />
				<p className="text-kaefer-dark-grey">{message}</p>
				<p className="text-xs text-muted-foreground">
					Troque o perfil simulado na faixa acima para ver outros acessos.
				</p>
				<Button
					variant="outline"
					onClick={() => navigate(ROUTES.OCCURRENCES.INDEX)}
				>
					Voltar à lista
				</Button>
			</div>
		</div>
	)
}
